if (window.bundleInitialized) {
  console.warn('[Bundle] Already initialized – skipping.');
} else {
  window.bundleInitialized = true;
  console.log('[Bundle] Initializing bundle logic');

  initBundleScript();
  updateBundlePrice();
}

function initBundleScript() {
  const bundleWrapper = document.querySelector('.product-bundle');
  if (!bundleWrapper) return;

  const bundleButton = bundleWrapper.querySelector('.bundle-add-to-cart');
  const variantSelectors = bundleWrapper.querySelectorAll('.bundle-variant-select');
  const originalPriceEl = bundleWrapper.querySelector('.bundle-original-price');
  const finalPriceEl = bundleWrapper.querySelector('.bundle-final-price');
  const badgeEl = bundleWrapper.querySelector('.bundle-discount-badge');
  const discountPercent = parseFloat(bundleWrapper.dataset.discount || '0');

  const subscriptionCheckbox = document.getElementById('bundle-subscription-checkbox');
  if (subscriptionCheckbox) subscriptionCheckbox.checked = true;

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  function updateBundlePrice() {
    let totalPrice = 0;

    variantSelectors.forEach(select => {
      const selectedOption = select.tagName === 'SELECT'
        ? select.options[select.selectedIndex]
        : select;
      const price = parseInt(selectedOption.dataset.price || '0', 10);
      totalPrice += price;
    });

    const discountedPrice = Math.round(totalPrice * (1 - discountPercent / 100));
    const percentOff = Math.round(100 * (totalPrice - discountedPrice) / totalPrice);

    if (originalPriceEl) originalPriceEl.textContent = formatMoney(totalPrice);
    if (finalPriceEl) finalPriceEl.textContent = formatMoney(discountedPrice);

    if (badgeEl) {
      badgeEl.textContent = `${percentOff}% OFF`;
      badgeEl.style.display = percentOff > 0 ? 'inline-block' : 'none';
    }
  }


  updateBundlePrice();

  if (subscriptionCheckbox) {
    subscriptionCheckbox.addEventListener('change', updateBundlePrice);
  }
  variantSelectors.forEach(select => select.addEventListener('change', updateBundlePrice));

  bundleButton?.addEventListener('click', function () {
    console.log('[Bundle] Handler attached from:', new Error().stack);

    const items = [];
    const isSubscription = subscriptionCheckbox?.checked;

    let sellingPlans = [];
    try {
      sellingPlans = JSON.parse(document.getElementById('bundle-selling-plans-json')?.textContent || '[]');
    } catch (e) {
      console.warn('[Bundle] Could not parse selling plans');
    }

    variantSelectors.forEach(select => {
      const variantId = select.value;
      if (!variantId) return;

      const item = { id: parseInt(variantId, 10), quantity: 1 };

      if (isSubscription) {
        const match = sellingPlans.find(plan => plan.product_id === parseInt(select.dataset.productId, 10));
        if (match) {
          item.selling_plan = match.selling_plan_id;
        }
      }

      console.log('[Bundle] Adding item:', item);
      items.push(item);
    });

    if (!items.length) return alert('Please select all items in the bundle.');

    bundleButton.classList.add('loading');
    bundleButton.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(response => {
      if (!response.ok) throw new Error('Bundle add failed');
      return response.json();
    })
    .then(data => {
      console.log('[Bundle] Successfully added to cart:', data);
      return fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`);
    })
    .then(res => res.json())
    .then(sections => {
      const cartDrawerEl = document.querySelector('cart-drawer');

      if (cartDrawerEl) {
        const parser = new DOMParser();
        const drawerHTML = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const newInner = drawerHTML.querySelector('#CartDrawer .drawer__inner');
        const oldInner = cartDrawerEl.querySelector('.drawer__inner');
        if (newInner && oldInner) oldInner.replaceWith(newInner);

        const overlay = cartDrawerEl.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', cartDrawerEl.close.bind(cartDrawerEl));

        const summary = cartDrawerEl.querySelector('[id^="Details-"] summary');
        if (summary && !summary.hasAttribute('role')) {
          summary.setAttribute('role', 'button');
          summary.setAttribute('aria-expanded', 'false');
          summary.parentElement.addEventListener('keyup', event => {
            if (event.code === 'Escape') cartDrawerEl.close();
          });
        }

        cartDrawerEl.classList.remove('is-empty');
        cartDrawerEl.open();
        console.log('[Bundle] Cart drawer opened');
      }

      const cartBubble = document.querySelector('#cart-icon-bubble');
      if (cartBubble) {
        const parser = new DOMParser();
        const bubbleHTML = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = bubbleHTML.querySelector('.shopify-section');
        if (newBubble) cartBubble.innerHTML = newBubble.innerHTML;
      }

      bundleButton.classList.remove('loading');
      bundleButton.classList.add('success');

      setTimeout(() => {
        bundleButton.classList.remove('success');
        const text = bundleButton.querySelector('.btn-text');
        if (text) text.style.opacity = '1';
      }, 1200);
    })
    .catch(error => {
      console.error('[Bundle] Error:', error);
      alert('There was a problem adding your bundle to the cart.');
    })
    .finally(() => {
      bundleButton.disabled = false;
      bundleButton.classList.remove('loading');
    });
  });
}

